export class OcrUploadDto {
  files?: File[] = undefined
}
